import React from "react";
import { Field, Form } from "react-final-form";
import { useDispatch, useSelector } from "react-redux";
import InputField from "../../General-UI/InputField";
import {
  CONFIRM_CODE_LENGTH,
  PASSWORD_REQUIREMENT,
} from "../../../constants/constants";
import { PASSWORD_REGEX } from "../../../constants/constants";
import {
  selectSuccessRegister,
  selectTryingRegister,
  selectUserResetError,
  selectUserResetPending,
  resetPasswordWithCode,
  signIn,
  setUser,
} from "slices/authSlice";
import TickIcon from "graphics/icons/TickIcon";

const validate = (formValues) => {
  const errors = {};
  if (!formValues.code) {
    errors.code = "Enter Your Code To Confirm";
  } else if (formValues.code.length !== 6) {
    errors.code =
      "The code sent is " + CONFIRM_CODE_LENGTH.toString() + " digits long";
  }

  if (!formValues.password) {
    errors.password = "You must enter a password";
  } else if (!formValues.password.match(PASSWORD_REGEX)) {
    errors.password = PASSWORD_REQUIREMENT;
  }

  return errors;
};

const parseCode = (value) => {
  if (!value) {
    return value;
  }
  return value.slice(0, 6);
};

const ForgotPasswordCode = ({ postSignIn }) => {
  const dispatch = useDispatch();
  const tryingRegister = useSelector(selectTryingRegister);
  const successRegister = useSelector(selectSuccessRegister);
  const userResetError = useSelector(selectUserResetError);
  const userResetPending = useSelector(selectUserResetPending);

  return (
    <div className={`inline-form ${userResetPending ? "" : "formHide"}`}>
      <div className="confirmed-email">
        {userResetPending ? userResetPending : null}
        <div className="svg-tick">
          <TickIcon />
        </div>
      </div>

      <div className="modal-text">
        Enter the verification code sent to your email and create a new password
        for your account:
      </div>
      <div className="modal-text-small">
        Can't find the code? Check junk mail
      </div>
      <div>
        <Form
          onSubmit={(formValues) => {
            if (userResetPending) {
              dispatch(
                resetPasswordWithCode({
                  email: userResetPending,
                  code: formValues.code,
                  password: formValues.password,
                })
              ).then(({ email, password }) => {
                signIn(email, password).then((user) => {
                  setUser(user)
                    .then(postSignIn)
                    .catch(() => {
                      window.efs_debug &&
                        window.log(
                          "Forgotton password set no post sign in. Could not set user from sign in"
                        );
                    });
                });
              });
            }
          }}
          validate={validate}
          render={({ handleSubmit, form }) => {
            if (!userResetPending) {
              form.restart();
            }
            return (
              <form onSubmit={handleSubmit}>
                <div>
                  <Field
                    name="code"
                    type="number"
                    parse={parseCode}
                    component={InputField}
                    placeholder="123456"
                    className="input-box verify-code-input"
                    liveCheck={true}
                  />
                </div>
                <div>
                  <Field
                    name="password"
                    component={InputField}
                    type="password"
                    placeholder="New Password"
                    className="input-box"
                    liveCheck={true}
                  />
                </div>
                {!successRegister ? (
                  <button
                    onClick={handleSubmit}
                    type="submit"
                    className="confirm-button business-button"
                    disabled={tryingRegister}
                  >
                    {tryingRegister ? "Checking..." : "Complete"}
                  </button>
                ) : (
                  <div className="success-register">
                    Password Changed. Logging In...
                    <div className="svg-tick">
                      <TickIcon />
                    </div>
                  </div>
                )}

                <div className="server-response-error">
                  {userResetError ? userResetError.message : null}
                </div>
              </form>
            );
          }}
        />
      </div>
    </div>
  );
};

export default ForgotPasswordCode;
